var React = require('react');

function UsbDrive (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M624 128H448v256h176a16 16 0 0 0 16-16V144a16 16 0 0 0-16-16zm-40 184a16 16 0 0 1-16 16h-16a16 16 0 0 1-16-16v-16a16 16 0 0 1 16-16h16a16 16 0 0 1 16 16zm0-96a16 16 0 0 1-16 16h-16a16 16 0 0 1-16-16v-16a16 16 0 0 1 16-16h16a16 16 0 0 1 16 16z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M448 112v288a16 16 0 0 1-16 16H64a64 64 0 0 1-64-64V160a64 64 0 0 1 64-64h368a16 16 0 0 1 16 16z","className":"fa-primary","key":2})]);
}

UsbDrive.defaultProps = {"viewBox":"0 0 640 512","className":"icon"};

module.exports = UsbDrive;

UsbDrive.default = UsbDrive;
